// extracted by mini-css-extract-plugin
module.exports = {"ntf__container":"Notifications_ntf__container__2ci1A","ntf__empty":"Notifications_ntf__empty__1rEbu"};